module.exports = __webpack_public_path__ + "img/icon_radio_checked@2x.9b83e89b.png";